import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=3d7ac81c"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=3d7ac81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports